<div class="px-1 pt-1 pb-2 fs-6 fst-italic" [innerHtml]="formatAsHTML(recipients, author, myUserId)"></div>